import React, { useState } from "react";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Grid,
  Link,
  Stack,
  Tab,
  Tabs,
  Typography,
  useMediaQuery,
} from "@mui/material";
import whiteExesAnimated from "../../assets/icons/white-exes-animated.gif";
import AddIcon from "@mui/icons-material/Add";

type AccordionData = {
  title: string;
  text: string;
};

const sxStyles = {
  mainContainer: {
    display: "flex",
    minHeight: { xs: "100%", md: "900px" },
    height: "auto",
    backgroundColor: "black",
    justifyContent: "flex-start",
    paddingTop: { xs: 0, md: "100px" },
    alignItems: "flex-start",
    position: "relative",
  },
  contentContainer: {
    display: "flex",
    flexDirection: { xs: "column", md: "row" },
    width: "100%",
    alignSelf: "flex-start",
    justifyContent: "center",
    paddingLeft: { xs: "35px", md: 0 },
    paddingRight: { xs: "35px", md: 0 },
  },
  title: {
    color: "white",
    fontFamily: "IBM Plex Sans",
    fontSize: "64px",
    lineHeight: "65px",
    fontWeight: "700",
    marginBottom: { xs: "56px", md: "50px" },
    textAlign: "left",
    marginTop: { xs: "50px", md: 0 },
  },
  tabName: {
    color: "white",
    fontFamily: "IBM Plex Sans",
    fontSize: "24px",
    lineHeight: "25px",
    fontWeight: "400",
  },
  tabUnderTextEmail: {
    color: "#FED301",
    fontFamily: "IBM Plex Sans",
    fontSize: "16px",
    lineHeight: "18px",
    fontWeight: "400",
    textAlign: "left",
    textDecoration: "none",
  },
  tabUnderText: {
    color: "white",
    fontFamily: "IBM Plex Sans",
    fontSize: "16px",
    lineHeight: "18px",
    fontWeight: "400",
    textAlign: "left",
  },
  accTitle: {
    color: "white",
    fontFamily: "IBM Plex Sans",
    fontSize: "16px",
    lineHeight: "18px",
    fontWeight: "700",
    textAlign: "center",
  },
  accText: {
    color: "white",
    fontFamily: "IBM Plex Sans",
    fontSize: "16px",
    lineHeight: "18px",
    fontWeight: "400",
    textAlign: "left",
  },
};

const FaqSection = () => {
  const [tabIndex, setTabIndex] = useState(0);
  const matches = useMediaQuery("(max-width:600px)");
  const questionsAll: Array<AccordionData> = [
    {
      title: "¿Que es BZRP Social Club?",
      text:
        "Bizarrap Social Club es la nueva aplicación oficial del Mundo\n" +
        "                Bizarrap. Es una Comunidad de Cards coleccionables que repasan\n" +
        "                la carrera musical de BZRP, desde la Session 1 hasta la Session\n" +
        "                52. También es un juego en el que podrás participar por\n" +
        "                increíbles premios y experiencias únicas.",
    },
    {
      title: "¿Que son las Cards?",
      text:
        "Las Cards son una Colección de imágenes referentes a todas las Sessions y todxs lxs artistas con los que ha " +
        "colaborado Bizarrap. Son un total de XXX y existen tres niveles de dificultad: fácil, intermedio y difícil.",
    },
    {
      title: "¿Dónde puedo ver qué Cards tengo?",
      text:
        "Puedes ver qué Cards tienes dentro de la App, en la sección Mis Cards." +
        "Allí mismo, también podrás eñegor cuáles quieres intercambiar.",
    },
    {
      title: "¿Puedo cambiar o vender mis Cards?",
      text:
        "¡Totalmente! Puedes cambiar tus Cards con otrxs usarixs dentro" +
        "del Area de Canje de la aplicación. Solo se pueden intercambiar Cards por otras del mismo nivel de dificultad." +
        "A partir del lanzamiento de la segunda Saga del álbum, también se podrán re-vender como NFTs lo que iniciará un" +
        "mercado de venta secundaria que permitirá la compra de Cards específicas (como NFTs) o Packs de Cards" +
        "adicionales en el marketplace Enigma. Esto te permitirá comprar, vender y coleccionar tus Cards de forma segura y" +
        "sin preocupaciones. Algunas de las imágenes mas importantes del álbum son tan buenas que te va a dar ganas de" +
        "tenerlas en todos lados. Por eso, también se podrán adquirir en formato wallpaper, autenticados como NFTs en" +
        "cantidad limitada.",
    },
    {
      title: "¿Cómo juego?",
      text:
        "Dentro de la app, ingresa en CARD DIARIA, responde la Trivia correctamente y" +
        "completa el Minijuego con al menos 75% de aciertos para recibir una Card gratis todos los días." +
        "También puedes ingresar al Area de Canje e intercambiar tus Cards con tus otrxs usuarxs dentro de" +
        "la Comunidad. Te recordamos que las Cards sólo se pueden intercambiar por otras del mismo nivel de dificultad",
    },
    {
      title: "¿Cómo gano premios?",
      text:
        "Bizarrap Social Club tiene 4 Niveles de Usario. Cada Nivel brinda acceso a" +
        "diferentes premios y experiencias." +
        "Ingresando en el Discord podrás participar por más premios." +
        "Podrás ganar Cards y Packs gratis, accesos a backstage y pruebas de sonido, entradas VIPs, merch exclusivo y" +
        "firmado, ser parte de streams exclusivos junto a algunos de los Streamers más famosos, un viaje todo incluído" +
        "a cualquier parte del Mundo para ver un show del Biza y muchos premios más...",
    },
    {
      title: "¿Cómo subo de Nivel?",
      text:
        "Podrás subir de Nivel interactuando con la aplicación, completando las sagas y participando de la Comunidad. Esto te permitirá acceder a diferentes premios y beneficios, tanto de forma digital como en la vida real, según tu Nivel.\n" +
        "\n" +
        "Para subir de Nivel, deberás cumplir al menos uno de los requerimientos que tiene cada Nivel.\n" +
        "\n" +
        "Nivel 1\n" +
        "Tener al menos 50 Cards (únicas o repetidas, de forma gratuita y/o comprando Packs);\n" +
        "Haber comprado al menos 10 Packs de Cards;\n" +
        "Ser Coleccionista de una de las primeras Cards Bizaphonix.\n" +
        "\n" +
        "Nivel 2\n" +
        "Juntar 100 Cards;\n" +
        "Tener al menos 5 POAPs de DalePlay o eventos de Bizarrap;\n" +
        "Comprar al menos 2 wallpapers (NFTs en Enigma.art);\n" +
        "Responder correctamente los retos en el canal de Discord del Nivel 1;\n" +
        "Ser Coleccionista de la serie 1 de la Gorra Mística (Enigma.art).\n" +
        "\n" +
        "Nivel 3\n" +
        "Completar el 50% del álbum;\n" +
        "Comprar los 4 Mixers y 4 Wallpapers en Enigma.art;\n" +
        "Ser Coleccionista de la serie 1 Bizarrap;\n" +
        "Responder correctamente los retos del canal Discord del Nivel 2;\n" +
        "Juntar 10 POAPs de DalePlay o eventos de Bizarrap;\n" +
        "Completar 2 Sagas.\n" +
        "\n" +
        "Nivel 4\n" +
        "Completar el 100% del álbum.\n" +
        "Ganar el concurso de Mixer.\n" +
        "Responder correctamente los retos del canal Discord del Nivel 3.\n" +
        "\n",
    },
    {
      title: "¿Puedo intercambiar las Cards?",
      text:
        "¡Claro! Puedes intercambiar tus Cards con otrxs usuarixs de la Comunidad. Ve al Área de Canje y selecciona cuál" +
        " quieres cambiar o ingresa en un álbum, haz tap sobre la Card que estés buscando y ofrece una de las que tengas" +
        " a cambio. La App se encargará del resto y muy pronto tendrás la Card que quieres dentro de tu Colección. " +
        "Sólo puedes intercambiar Cards por otras del mismo nivel de dificultad. Por ejemplo: puedes cambiar una dificil " +
        "por otra dificil, pero no podrías cambiarla por una fácil ó una intermedia.",
    },
    {
      title: "¿Qué es un Mixer?",
      text:
        "Como habrás notado, algunas de las Sessiones tienen un formato especial de poster: cada una de las Cards " +
        "que conforman ese poster es, además, el loop de audio de un instrumento de la Session. Una vez que logras juntar" +
        " las cuatro Cards, habrás conseguido un Mixer, un fragmento sonoro de una Session que te permite jugar y experimentar" +
        " con las partes de la canción por separado. Este Mixer es, a su vez, un NFT en sí mismo y lo puedes guardar" +
        "en tu Wallet por fuera del álbum.",
    },
  ];
  const questionsApp: Array<AccordionData> = [
    {
      title: "¿Que es BZRP Social Club?",
      text:
        "Bizarrap Social Club es la nueva aplicación oficial del Mundo\n" +
        "                Bizarrap. Es una Comunidad de Cards coleccionables que repasan\n" +
        "                la carrera musical de BZRP, desde la Session 1 hasta la Session\n" +
        "                52. También es un juego en el que podrás participar por\n" +
        "                increíbles premios y experiencias únicas.",
    },
    {
      title: "¿Que son las Cards?",
      text:
        "Las Cards son una Colección de imágenes referentes a todas las Sessions y todxs lxs artistas con los que ha " +
        "colaborado Bizarrap. Son un total de XXX y existen tres niveles de dificultad: fácil, intermedio y difícil.",
    },
    {
      title: "¿Dónde puedo ver qué Cards tengo? ",
      text:
        "Puedes ver qué Cards tienes dentro de la App, en la sección Mis Cards." +
        "Allí mismo, también podrás eñegor cuáles quieres intercambiar.",
    },
    {
      title: "¿Puedo cambiar o vender mis Cards?",
      text:
        "¡Totalmente! Puedes cambiar tus Cards con otrxs usarixs dentro" +
        "del Area de Canje de la aplicación. Solo se pueden intercambiar Cards por otras del mismo nivel de dificultad." +
        "A partir del lanzamiento de la segunda Saga del álbum, también se podrán re-vender como NFTs lo que iniciará un" +
        "mercado de venta secundaria que permitirá la compra de Cards específicas (como NFTs) o Packs de Cards" +
        "adicionales en el marketplace Enigma. Esto te permitirá comprar, vender y coleccionar tus Cards de forma segura y" +
        "sin preocupaciones. Algunas de las imágenes mas importantes del álbum son tan buenas que te va a dar ganas de" +
        "tenerlas en todos lados. Por eso, también se podrán adquirir en formato wallpaper, autenticados como NFTs en" +
        "cantidad limitada.",
    },
    {
      title: "¿Cómo juego?",
      text:
        "Dentro de la app, ingresa en CARD DIARIA, responde la Trivia correctamente y" +
        "completa el Minijuego con al menos 75% de aciertos para recibir una Card gratis todos los días." +
        "También puedes ingresar al Area de Canje e intercambiar tus Cards con tus otrxs usuarxs dentro de" +
        "la Comunidad. Te recordamos que las Cards sólo se pueden intercambiar por otras del mismo nivel de dificultad",
    },
    {
      title: "¿Cómo gano premios?",
      text:
        "Bizarrap Social Club tiene 4 Niveles de Usario. Cada Nivel brinda acceso a" +
        "diferentes premios y experiencias." +
        "Ingresando en el Discord podrás participar por más premios." +
        "Podrás ganar Cards y Packs gratis, accesos a backstage y pruebas de sonido, entradas VIPs, merch exclusivo y" +
        "firmado, ser parte de streams exclusivos junto a algunos de los Streamers más famosos, un viaje todo incluído" +
        "a cualquier parte del Mundo para ver un show del Biza y muchos premios más...",
    },
    {
      title: "¿Cómo subo de Nivel?",
      text:
        "Podrás subir de Nivel interactuando con la aplicación, completando las sagas y participando de la Comunidad. Esto te permitirá acceder a diferentes premios y beneficios, tanto de forma digital como en la vida real, según tu Nivel.\n" +
        "\n" +
        "Para subir de Nivel, deberás cumplir al menos uno de los requerimientos que tiene cada Nivel.\n" +
        "\n" +
        "Nivel 1\n" +
        "Tener al menos 50 Cards (únicas o repetidas, de forma gratuita y/o comprando Packs);\n" +
        "Haber comprado al menos 10 Packs de Cards;\n" +
        "Ser Coleccionista de una de las primeras Cards Bizaphonix.\n" +
        "\n" +
        "Nivel 2\n" +
        "Juntar 100 Cards;\n" +
        "Tener al menos 5 POAPs de DalePlay o eventos de Bizarrap;\n" +
        "Comprar al menos 2 wallpapers (NFTs en Enigma.art);\n" +
        "Responder correctamente los retos en el canal de Discord del Nivel 1;\n" +
        "Ser Coleccionista de la serie 1 de la Gorra Mística (Enigma.art).\n" +
        "\n" +
        "Nivel 3\n" +
        "Completar el 50% del álbum;\n" +
        "Comprar los 4 Mixers y 4 Wallpapers en Enigma.art;\n" +
        "Ser Coleccionista de la serie 1 Bizarrap;\n" +
        "Responder correctamente los retos del canal Discord del Nivel 2;\n" +
        "Juntar 10 POAPs de DalePlay o eventos de Bizarrap;\n" +
        "Completar 2 Sagas.\n" +
        "\n" +
        "Nivel 4\n" +
        "Completar el 100% del álbum.\n" +
        "Ganar el concurso de Mixer.\n" +
        "Responder correctamente los retos del canal Discord del Nivel 3.\n" +
        "\n",
    },
    {
      title: "¿Puedo intercambiar las Cards?",
      text:
        "¡Claro! Puedes intercambiar tus Cards con otrxs usuarixs de la Comunidad. Ve al Área de Canje y selecciona cuál" +
        " quieres cambiar o ingresa en un álbum, haz tap sobre la Card que estés buscando y ofrece una de las que tengas" +
        " a cambio. La App se encargará del resto y muy pronto tendrás la Card que quieres dentro de tu Colección. " +
        "Sólo puedes intercambiar Cards por otras del mismo nivel de dificultad. Por ejemplo: puedes cambiar una dificil " +
        "por otra dificil, pero no podrías cambiarla por una fácil ó una intermedia.",
    },
  ];

  let questions: AccordionData[] = [];

  switch (tabIndex) {
    case 0:
      questions = questionsAll;
      break;
    case 1:
      questions = questionsApp;
      break;
    default:
      questions = [];
  }

  const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
    setTabIndex(newValue);
  };
  return (
    <Box sx={sxStyles.mainContainer} id={"faqs"}>
      <Stack>
        <Box
          sx={{
            height: { xs: "60px", md: "30px" },
            width: "320px",
            position: "absolute",
            left: { xs: "-25px", md: "550px" },
            top: "0",
          }}
        >
          <img
            src={whiteExesAnimated}
            style={{ height: "60px", width: "320px" }}
          />
        </Box>
        <Box
          sx={{
            height: "60px",
            width: "320px",
            position: "absolute",
            left: "50px",
            top: "-30px",
          }}
        >
          <img
            src={whiteExesAnimated}
            style={{
              height: "60px",
              width: "320px",
            }}
          />
        </Box>
      </Stack>

      <Grid sx={sxStyles.contentContainer}>
        <Stack
          sx={{
            marginRight: { xs: 0, md: "150px" },
            justifyContent: { xs: "center", md: "left" },
            display: "flex",
            flexDirection: "column",
          }}
        >
          <Typography sx={sxStyles.title}>FAQS</Typography>
          <Stack
            sx={{
              display: "flex",
              flexDirection: { xs: "column-reverse", md: "column" },
            }}
          >
            <Tabs
              orientation={matches ? "horizontal" : "vertical"}
              value={tabIndex}
              onChange={handleTabChange}
              textColor={"secondary"}
              indicatorColor={"secondary"}
              sx={{ marginBottom: { xs: "35px", md: 0 } }}
            >
              <Tab label={"Todos"} sx={sxStyles.tabName} />
              <Tab label={"App"} sx={sxStyles.tabName} />
            </Tabs>
            <Stack sx={{ marginBottom: { xs: "50px", md: 0 } }}>
              <Typography sx={sxStyles.tabUnderText}>Escríbenos a</Typography>
              <Link
                href="mailto:bzrp@enigma.art"
                target={"_blank"}
                sx={{ textDecoration: "none" }}
              >
                <Typography sx={sxStyles.tabUnderTextEmail}>
                  bzrp@enigma.art
                </Typography>
              </Link>
            </Stack>
          </Stack>
        </Stack>
        <Stack>
          {questions.map((item: AccordionData, index: number) => {
            return (
              <Accordion
                key={index}
                sx={{
                  backgroundColor: "transparent",
                  borderBottom: "solid",
                  borderBottomColor: "white",
                  display: "flex",
                  flexDirection: "column",
                  width: { xs: "320px", md: "740px" },
                  marginBottom: { xs: "50px", md: 0 },
                }}
              >
                <AccordionSummary
                  expandIcon={<AddIcon sx={{ color: "white" }} />}
                >
                  <Typography sx={sxStyles.accTitle}>{item.title}</Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Typography sx={sxStyles.accText}>{item.text}</Typography>
                </AccordionDetails>
              </Accordion>
            );
          })}
        </Stack>
      </Grid>
    </Box>
  );
};

export default FaqSection;
